import {
  Validator
} from 'vee-validate';
import {
  BasicSelect
} from 'vue-search-select';
import DatePicker from 'vue2-datepicker';
// import weightdimension from './../weightdimension/index.vue';
import MasterClientContract from './../../../../masterdata/views/contracttemplate/createContractTemplate';
import CONSTANT from './../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import ClientService from '../../../services/clientmanagement.service';
import MasterService from './../../../../masterdata/services/masterdata.service'
import createRateTemplate from './../../../../masterdata/views/ratetemplate/createratetemplate'
import RateTemplateView from './../../../../masterdata/views/ratetemplate/ratetemplateview'
import moment from 'moment';
import Util from './../../../../shared/util/util'
import Multiselect from 'vue-multiselect'
export default {
  name: 'rates',
  components: {
    BasicSelect,
    DatePicker,
    VueElementLoading,
    Pagination,
    CustomExpandableTable,
    // 'first': weightdimension,
    MasterClientContract,
    createRateTemplate,
    RateTemplateView,
    Multiselect
  },
  props: [],
  data() {
    return {
      isLoading: false,
      showRate: true,
      listData:[],
      tableColumn: ['Company', 'Contract ID', 'Truck Load Type', 'Route Mode', 'Service Type', 'Booking Type', 'Rates Defined', 'Effective Date From','Effective Date To','Created By','Created Date','Last Modified By','Last Modified Date','Contract Status', 'Rate Action'],
      innerTableColumn: [],
      tableItems: [],
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      companyshortnamelist: [],
      companyshortnameitem: {
        text: '',
        value: ''
      },
      companyshortname: '',
      clientsystemid: '',
      contractidlist: [],
      contractiditem: {
        text: '',
        value: ''
      },
      selectedContractID: '',
      contractid: '',
      truckloadtypelist: [{
        text: "FTL ",
        value: "FTL"
      }, {
        text: "PTL ",
        value: "PTL"
      }],
      truckloadtypeitem: {
        text: '',
        value: ''
      },
      truckloadtype: '',
      routemodelist: [{
        text: "Surface ",
        value: "Surface"
      }, {
        text: "Air ",
        value: "Air"
      }],
      routemodeitem: {
        text: '',
        value: ''
      },
      routemode: '',
      servicetypelist: [{
        text: "Forward ",
        value: "Forward"
      }, {
        text: "Reverse ",
        value: "Reverse"
      }],
      servicetypeitem: {
        text: '',
        value: ''
      },
      servicetype: '',
      bookingmodelist: [{
        text: "Credit ",
        value: "Credit"
      }, {
        text: "To Pay ",
        value: "To Pay"
      },
      {
        text: "PrePaid ",
        value: "PrePaid"
      }],
      bookingmodeitem: {
        text: '',
        value: ''
      },
      bookingmode: '',
      ratesdefined: '',
      callingFromObj: {

      },
      innerTableColumn: [],
      selectedEditRow: '',
      rateArr: [],
      fromDate: '',
      toDate: '',
      selectedServiceId: '',
      selectedClientContractId: '',
      selectedEdit: [],
      showRateView: false,
    }
  },
  computed: {

  },
  mounted() {
    this.getCompanyShortNameList();
  },
  methods: {
    eventFromChild() {
      this.getServicesList();
      //this.getServicesList(this.selectedClientContractId)
    },
    // selectedCompanyShortName(data) {

    // },
    selectContractID(data) {
      this.contractiditem = data;
      this.contractid = data.text;
      //this.tableItems = [];
    },
    selectTruckLoadType(data) {
      this.truckloadtypeitem = data;
    },
    selectRouteMode(data) {
      this.routemodeitem = data;
    },
    selectServiceType(data) {
      this.servicetypeitem = data;
    },
    selectBookingMode(data) {
      this.bookingmodeitem = data;
    },
    async getCompanyShortNameList() {
      try {
        this.isLoading = true;
        var CompanyShortList = []
        let result = await ClientService.getActiveInactiveClientList()
        CompanyShortList = this.getUniqueCompanyList(result.data.data);
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyshortnamelist.push({
            'value': CompanyShortList[i].ClientMasterID,
            'text': CompanyShortList[i].ClientShortName,
            'ClientBusinessAccountId' : CompanyShortList[i].ClientBusinessAccountId,
          })
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    getUniqueCompanyList(array){
      let mymap = new Map();
      let unique = array.filter(el => {
          const val = mymap.get(el.ClientMasterID);
          if(val) {
              if(el.ClientShortName < val) {
                  mymap.delete(el.ClientMasterID);
                  mymap.set(el.ClientMasterID, el.ClientShortName, el.ClientBusinessAccountId);
                  return true;
              } else {
                  return false;
              }
          }
          mymap.set(el.ClientMasterID, el.ClientShortName,el.ClientBusinessAccountId);
          return true;
      });
      return unique;
    },
    async getContractList(companyId) {
      try {
        this.contractidlist = [];

        this.isLoading = true;
        let inputPayload = {
          clientbusinessaccountid: companyId
        };
        let result = await ClientService.getClientContractDropdownList(inputPayload);
        let contractlist = result.data.data;
        for (var i = 0; i < contractlist.length; i++) {
          this.contractidlist.push({
            'value': contractlist[i].id,
            'text': contractlist[i].contractidlabel
          });
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    getCustomTableEvent(event, dateEvent) {

      this.showRateView = false

      if(dateEvent &&  (!this.callingFromObj.rateeffectivedatefrom || !this.callingFromObj.rateeffectivedateto)){
        return;
      }
      if (event.actionType == "view") {
        let selectedEdit = this.listData.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedEdit = {
          id: selectedEdit[0].clientcontractid,
          ratetemplateid: selectedEdit[0].clientratetemplateid,
          serviceid: selectedEdit[0].contractservicesid,
          status: selectedEdit[0].status,
          view: true
        }
        this.selectedEdit.ComponentName = CONSTANT.CLIENT_CONTRACT_TEMPLATE
        this.$nextTick(() => {
          this.$refs.childRateViewComponentFromListing && this.$refs.childRateViewComponentFromListing.setValues(this.selectedEdit);
        })
        this.showRateView = true
        this.showRate = false;

      } else if (event.actionType == "edit" || event.actionType == "defineRate" || event.actionType == 'editRate') {
        this.showRateView = false;
        this.selectedServiceId = event.id;
        // let RateDetails = this.rateArr.filter(function(items) {
        //   return items.contractservicesid == event.id;
        // });
          this.$validator.validateAll().then((result) => {
            if(result){
              if(event.actionType == "defineRate" || event.actionType == 'editRate'){
                this.callingFromObj = {}
              }
              let serviceDetails = this.listData.filter(function(items) {
                  return items.id == event.id;
              });
              this.showRate = false;
              this.$nextTick(() => {
                this.callingFromObj = {
                  id: serviceDetails[0].clientratetemplateid,
                  name: CONSTANT.CLIENT_CONTRACT_TEMPLATE,
                  contractid: serviceDetails[0].clientcontractid,
                  contractservicesid: serviceDetails[0].id,
                  rateeffectivedatefrom: this.callingFromObj.rateeffectivedatefrom || (serviceDetails[0].rateeffectivedatefrom) || null,
                  rateeffectivedateto: this.callingFromObj.rateeffectivedateto || (serviceDetails[0].rateeffectivedateto) || null,
                  contractRateTemplateDetails:{
                    ratetemplatemasterid: serviceDetails[0].ratetemplatemasterid
                  }
                }
                this.$nextTick(() => {
                  this.$validator.validateAll().then((value)=>{
                    if(value){
                      this.showRate = true;
                    }
                  }).catch(() => {
                    console.log('errors exist ::', this.errors)
                  });
                })

                //this.fromDate = this.fromDate || RateDetails[0].rateeffectivedatefrom;
                //this.toDate = this.toDate || RateDetails[0].rateeffectivedatefrom;

              })
            } else {
              this.showRate = false;
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
      }
      // else if (event.actionType == "definerate") {
      //   this.selectedServiceId = event.id;
      //   let RateDetails = this.rateArr.filter(function(items) {
      //     return items.contractservicesid == event.id;
      //   });
      //   this.showRate = false;
      //   this.$nextTick(() => {
      //     let serviceDetails = this.tableArr.filter(function(items) {
      //       return items.id == event.id;
      //     });
      //     this.callingFromObj = {
      //       id: null,
      //       name: CONSTANT.CLIENT_CONTRACT_TEMPLATE,
      //       contractid: serviceDetails[0].clientcontractid,
      //       contractservicesid: serviceDetails[0].id,
      //       //rateeffectivedatefrom: this.fromDate,
      //       //rateeffectivedateto: this.toDate,
      //     }
      //     console.log( this.callingFromObj);
      //     this.showRate = true;
      //   })
      // }
    },
    selectCompanyShortName(data) {
      if(data.text){
        this.companyshortnameitem.text = data.text;
        this.companyshortnameitem.value = data.value;
        this.clientbusinessaccountid = data.ClientBusinessAccountId;
        this.companyshortname = data.value;
        this.contractiditem.value = "",
        this.contractid = ""
        this.contractiditem.text = "";
        this.tableItems = [];
        this.getContractList(this.clientbusinessaccountid);
      }

      // this.getClientContractDetails(data.value);
    },


    async getServicesList() {
      try {
        let payload = {
          offset : this.offset,
          limit : 10,
          clientContractIds : this.contractidlist.map((data)=>data.value)
        }
        if(this.contractiditem.value){
          payload.clientContractIds = [this.contractiditem.value]
        }
        if(this.truckloadtypeitem.value){
          payload.truckloadtypeitem = this.truckloadtypeitem.value
        }
        if(this.routemodeitem.value){
          payload.routemodeitem = this.routemodeitem.value
        }
        if(this.servicetypeitem.value){
          payload.servicetypeitem = this.servicetypeitem.value
        }
        if(this.bookingmodeitem.value){
          payload.bookingmodeitem = this.bookingmodeitem.value
        }
        this.isLoading = true;
        let result = await ClientService.getClientRateList(payload);
        this.isLoading = false;
        this.totalCount = result.data.data && (result.data.data[0] && Number(result.data.data[0].count)) || 0
        this.totalPage = Math.ceil(this.totalCount/this.pageLimit);
        this.listData = this.totalCount && result.data.data;
        this.tableItems = result.data.data && result.data.data.map((el)=>{
          let tempArr = []
					el.bookingtype.forEach((item) => {
						let type = CONSTANT.BOOKING_MODE[item]
						tempArr.push(type)
					});
          return {
            'id': el.id,
              'Company': this.companyshortnameitem.text,
              'Contract ID': this.contractidlist.find((data)=> data.value == el.clientcontractid).text,
              'Truck Load Type': el.truckloadtype,
              'Route Mode': el.routemode,
              'Service Type': el.servicetype,
              'Booking Type': tempArr.join(", "),
              'Rates Defined':el.clientratetemplateid ? 'Y' : 'N',
              'Effective Date From': el.rateeffectivedatefrom && this.format_date(el.rateeffectivedatefrom),
              'Effective Date To': el.rateeffectivedateto && this.format_date(el.rateeffectivedateto),
              'Created By':el.createdby,
	            'Created Date':Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              //'Effective Date': (el.rateeffectivedatefrom && el.rateeffectivedateto) && `From ${this.format_date(el.rateeffectivedatefrom)} To ${this.format_date(el.rateeffectivedateto)}`,
              'Rate Action': (el.contractstatus == 0 || el.contractstatus == 3) ? !el.clientratetemplateid : 'no-view',
              'Contract Status': CONSTANT.CONTRACT_STATUS[el.contractstatus]
          }
        })
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
      }
    },
    searchRates() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.getServicesList(this.contractiditem.value);
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },

    dropdownFiller(){
      this.truckloadtypelist= [{
        text: "FTL ",
        value: "FTL"
      }, {
        text: "PTL ",
        value: "PTL"
      }],

      this.routemodelist= [{
        text: "Surface ",
        value: "Surface"
      }, {
        text: "Air ",
        value: "Air"
      }];
      this.servicetypelist= [{
        text: "Forward ",
        value: "Forward"
      }, {
        text: "Reverse ",
        value: "Reverse"
      }];
      this.bookingmodelist= [{
        text: "Credit ",
        value: "Credit"
      }, {
        text: "To Pay ",
        value: "To Pay"
      }, {
        text: "PrePaid ",
        value: "PrePaid"
      }]
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getServicesList();
    },
    resetRates() {
      this.contractiditem.value = "";
      this.contractiditem.text = "";
      this.contractid = "";
      this.companyshortnameitem.text = "";
      this.companyshortnameitem.value = "";
      this.companyshortname = "";
      this.truckloadtypeitem.text = "";
      this.truckloadtypeitem.value = "";
      this.routemodeitem.text="";
      this.routemodeitem.value="";
      this.servicetypeitem.text="";
      this.servicetypeitem.value="";
      this.bookingmodeitem.text="",
      this.bookingmodeitem.value="",
      this.dropdownFiller();
      this.tableItems = [];
      this.totalCount = 0;
      this.offset = 0;
      this.contractidlist = [];
      this.$validator.reset();
    }
  }
}
Validator.extend('verifyTodate', {
  getMessage: field => "Rate Effective To Date should be greater than Rate Effective From Date.",
  validate: value => {
    var todate = new Date($("#EffectiveTodate").val());
    var fromdate = new Date($("#EffectiveFromdate").val());
     if (fromdate >= todate) {
      return false;
    }else{
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientRates/ClientRatesListing/ClientRatesListing.component.js